enum ImageWidgetSourceType {
  SOCIAL_IMAGE_POST = 'social-image-post',
}

interface ImagesetItem {
  title: string
  caption: string
  alt: string
  source: string
  url: string
  id: number
  source_url?: string
  buy3?: string
  blur: boolean
}

interface ImagesetWidget {
  flip: boolean
  images: ImagesetItem[]
}

export { ImageWidgetSourceType }

export type { ImagesetItem, ImagesetWidget }
